/* eslint-disable */
import { endpoints } from '../../Constants';
import { authHeader } from '../../Helpers';
import handleResponse from '../helpers';

function createEditOrganisation(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };
    return fetch(endpoints.VENDOR_ORGANISATION_CREATE_EDIT, requestOptions).then(handleResponse);
}

function listOrganisations(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };
    return fetch(endpoints.VENDOR_ORGANISATION_LIST, requestOptions).then(handleResponse);
}

function deleteOrganisation(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };
    return fetch(endpoints.VENDOR_ORGANISATION_DELETE, requestOptions).then(handleResponse);
}



function listVendorMappings(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };
    return fetch(endpoints.VENDOR_ORGANISATION_MAP_LIST, requestOptions).then(handleResponse);
}

function mapOrganisationVendors(req) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ ...req?.data }),
    };
    return fetch(endpoints.VENDOR_ORGANISATION_VENDORS_MAP, requestOptions).then(handleResponse);
}

export const vendorOrganisationServices = {
    createEditOrganisation,
    listOrganisations,
    deleteOrganisation,
    listVendorMappings,
    mapOrganisationVendors,
};
